var Member = new Object();

Member.memberId = -1;
Member.memberProfileId = -1;
Member.candidate = false;
Member.viewType; // SELF, PROFILE, or CANDIDATE, or COMMITTEE

Member.clearMemberId = function(event,fieldName) {
	if (fieldName === undefined) {
		fieldName = 'hdnMemberId';
	}
	Util.clearHiddenAutocompleteId(event,fieldName);
}

Member.showError = function(strErrorMsg) {
	$('#memberErrorDiv').html(strErrorMsg);
}

Member.hideError = function() {
	$('#memberErrorDiv').html('');
}

Member.onInvalid = function(strValidationMessage) {
	try {
		Util.showTab('memberTabs',$('.form .error:first').closest('.tabBody')[0].id.replace('tabBody',''));
	} catch(err) {
		//alert('error showing tab: ' + err);
	}
	$('.validationError').html(strValidationMessage).show();
}


Member.deleteMembershipCandidate = function(membershipCandidateId) {
  if (confirm('Are you sure you want to delete this proposed member?')) {
    doAction('/admin/members/doDeleteMembershipCandidate?membershipCandidateId='+membershipCandidateId);    
  }
}


/**
* objOptions includes: strPath, width (optional)
*/
Member.addItem = function(objOptions) {
	if (objOptions.width === undefined) {
		objOptions.width = 500;
	}
	Util.showPopup('/members/profile/' + objOptions.strPath + '/create?memberProfileId=' + Member.memberProfileId + '&memberId=' + Member.memberId + '&isCandidate=' + Member.candidate,objOptions.width,'memberProfileDiv');
}

/**
* objOptions includes: strPath, width (optional), strIdName, intId
*/
Member.editItem = function(objOptions) {	
	if (objOptions.width === undefined) {
		objOptions.width = 500;
	}
	Util.showPopup('/members/profile/' + objOptions.strPath + '/edit?memberId='+Member.memberId+'&memberProfileId=' + Member.memberProfileId + '&isCandidate=' + Member.candidate + '&' + objOptions.strIdName + '='+objOptions.intId,objOptions.width,'memberProfileDiv');
}

/**
* objOptions includes: strPath, strIdName, intId, strLabel
*/
Member.deleteItem = function(objOptions) {
	Member.objOptions = objOptions; // make it global so can access it from the refresh fn
	var arrData = {memberId:Member.memberId,memberProfileId:Member.memberProfileId};
	arrData[objOptions.strIdName]=objOptions.intId;
	Util.confirm('Are you sure you want to delete this ' + objOptions.strLabel + '?',function() {
		$.ajax({type: 'POST',	
			url: '/members/profile/' + objOptions.strPath + '/delete',
			data: arrData,
			success: Member.refreshItem,
			error: function() {
				Member.showError('The system encountered an error while trying to delete the ' + objOptions.strLabel + '.  Please refresh the page and try again.');
			}
		});
		
	});
}

/**
* objOptions includes: strPath, fnRefresh, bAddAnother
*/
Member.saveItem = function(objOptions) {
	Util.clearErrors(true);
	Member.objOptions = objOptions; // make it global so can access it from the refresh fn
	var bSuccess = Util.submitForm({
		bPopup:true,
		bValidate:true,
		strURL:'/members/profile/' + objOptions.strPath + '/save',
		strFormName:'frmPopup',
		fnClearErrors:function() {Util.clearErrors(true);},
		fnOnInvalid:function(strValidationMessage) {
			$('.divErrorPopup').html(strValidationMessage);
			$('.divErrorPopup').show();
		},
		fnOnSuccess:function(strHtml) {
			if (strHtml == 'SUCCESS') {
				Member.refreshItem();
				if (objOptions.bAddAnother) {
					Member.addItem(objOptions);
				} else {
					// close the popup
					Util.closePopup();
				}
			} else {
				// some error
				$('#memberProfileDiv').html(strHtml);
			}
		}
	});		
}

/**
* objOptions includes: strPath, strLabel, strDivName
*/
Member.refreshItem = function() {
	//alert('in refreshItem, objOptions: ' + Member.objOptions);
	Member.hideError();
	$.ajax({type: 'GET',	
		url: '/members/profile/' + Member.objOptions.strPath + '/view',
		data: {memberId:Member.memberId,memberProfileId:Member.memberProfileId,viewType:Member.viewType},
		success: function(strHtml) {
			$('#'+Member.objOptions.strDivName).html(strHtml);
		},
		error: function() {
			Member.showError('The system encountered an error while trying to list the ' + Member.objOptions.strLabel + '.  Please refresh the page and try again.');
		}
	});
}

/**************************
********* CHILDREN  *******
**************************/

Member.addChild = function(bAddAnother) {
	Member.addItem({strPath:'child', strLabel:'child', strIdName:'memberChildId', strDivName:'memberChildrenDiv'});
}

Member.editChild = function(memberChildId) {	
	Member.editItem({strPath:'child', strLabel:'child', strIdName:'memberChildId', strDivName:'memberChildrenDiv', intId:memberChildId, strDivName:'memberChildrenDiv'});
}

Member.deleteChild = function(memberChildId) {
	Member.deleteItem({strPath:'child', strLabel:'child', strIdName:'memberChildId', strDivName:'memberChildrenDiv', intId:memberChildId});
}

Member.saveChild = function(bAddAnother) {
	Member.saveItem({strPath:'child', strLabel:'child', strIdName:'memberChildId', strDivName:'memberChildrenDiv', bAddAnother:bAddAnother});
}


/**************************
********* EDUCATION *******
**************************/

Member.addEducation = function() {
	Member.addItem({width:500, strPath:'education', strLabel:'education history', strIdName:'memberEducationId', strDivName:'memberEducationsDiv'});
}

Member.editEducation = function(memberEducationId) {	
	Member.editItem({width:500, strPath:'education', strLabel:'education history', strIdName:'memberEducationId', intId:memberEducationId, strDivName:'memberEducationsDiv'});
}

Member.deleteEducation = function(memberEducationId) {
	Member.deleteItem({strPath:'education', strLabel:'education history', strIdName:'memberEducationId', intId:memberEducationId, strDivName:'memberEducationsDiv'});
}

Member.saveEducation = function(bAddAnother) {
	Member.saveItem({strPath:'education', strLabel:'education history', strIdName:'memberEducationId', strDivName:'memberEducationsDiv', bAddAnother:bAddAnother});
}

/**************************
********* EMPLOYMENT *******
**************************/

Member.addEmployment = function() {
	Member.addItem({width:500, strPath:'employment', strLabel:'employment history', strIdName:'memberEmploymentId', strDivName:'memberEmploymentsDiv'});
}

Member.editEmployment = function(memberEmploymentId) {	
	Member.editItem({width:500, strPath:'employment', strLabel:'employment history', strIdName:'memberEmploymentId', intId:memberEmploymentId, strDivName:'memberEmploymentsDiv'});
}

Member.deleteEmployment = function(memberEmploymentId) {
	Member.deleteItem({strPath:'employment', strLabel:'employment history', strIdName:'memberEmploymentId', intId:memberEmploymentId, strDivName:'memberEmploymentsDiv'});
}

Member.saveEmployment = function(bAddAnother) {
	Member.saveItem({strPath:'employment', strLabel:'employment history', strIdName:'memberEmploymentId', strDivName:'memberEmploymentsDiv', bAddAnother:bAddAnother});
}

/**************************
********* INTEREST/EXPERTISE *******
**************************/

Member.addMemberInterestExpertise = function() {
	Member.addItem({width:500, strPath:'interestExpertise', strLabel:'interest/expertise', strIdName:'memberInterestExpertiseId', strDivName:'memberInterestsExpertiseDiv'});
}

Member.editMemberInterestExpertise = function(memberInterestExpertiseId) {	
	Member.editItem({width:500, strPath:'interestExpertise', strLabel:'interest/expertise', strIdName:'memberInterestExpertiseId', intId:memberInterestExpertiseId, strDivName:'memberInterestsExpertiseDiv'});
}

Member.deleteMemberInterestExpertise = function(memberInterestExpertiseId) {
	Member.deleteItem({strPath:'interestExpertise', strLabel:'interest/expertise', strIdName:'memberInterestExpertiseId', intId:memberInterestExpertiseId, strDivName:'memberInterestsExpertiseDiv'});
}

Member.saveMemberInterestExpertise = function(bAddAnother) {
	Member.saveItem({strPath:'interestExpertise', strLabel:'interest/expertise', strIdName:'memberInterestExpertiseId', strDivName:'memberInterestsExpertiseDiv', bAddAnother:bAddAnother});
}

/**************************
********* LECTURES ********
**************************/

Member.addLecture = function() {
	Member.addItem({width:800, strPath:'lecture', strLabel:'lecture', strIdName:'memberLectureId', strDivName:'memberLecturesDiv'});
}

Member.editLecture = function(memberLectureId) {	
	Member.editItem({width:800, strPath:'lecture', strLabel:'lecture', strIdName:'memberLectureId', intId:memberLectureId, strDivName:'memberLecturesDiv'});
}

Member.deleteLecture = function(memberLectureId) {
	Member.deleteItem({strPath:'lecture', strLabel:'lecture', strIdName:'memberLectureId', intId:memberLectureId, strDivName:'memberLecturesDiv'});
}

Member.saveLecture = function(bAddAnother) {
	Member.saveItem({strPath:'lecture', strLabel:'lecture', strIdName:'memberLectureId', strDivName:'memberLecturesDiv', bAddAnother:bAddAnother});
}

/**************************
********* PUBLICATIONS *******
**************************/

Member.addPublication = function() {
	Member.addItem({strPath:'publication', strLabel:'publication', strIdName:'memberPublicationId', strDivName:'memberPublicationsDiv'});
}

Member.editPublication = function(memberPublicationId) {	
	Member.editItem({strPath:'publication', strLabel:'publication', strIdName:'memberPublicationId', intId:memberPublicationId, strDivName:'memberPublicationsDiv'});
}

Member.deletePublication = function(memberPublicationId) {
	Member.deleteItem({strPath:'publication', strLabel:'publication', strIdName:'memberPublicationId', intId:memberPublicationId, strDivName:'memberPublicationsDiv'});
}

Member.savePublication = function(bAddAnother) {
	Member.saveItem({strPath:'publication', strLabel:'publication', strIdName:'memberPublicationId', strDivName:'memberPublicationsDiv', bAddAnother:bAddAnother});
}

/**************************
********* COLLECTIONS******
**************************/

Member.addCollection = function() {
	Member.addItem({strPath:'collection', strLabel:'collection', strIdName:'memberCollectionId', strDivName:'memberCollectionsDiv'});
}

Member.editCollection = function(memberCollectionId) {	
	Member.editItem({strPath:'collection', strLabel:'collection', strIdName:'memberCollectionId', intId:memberCollectionId, strDivName:'memberCollectionsDiv'});
}

Member.deleteCollection = function(memberCollectionId) {
	Member.deleteItem({strPath:'collection', strLabel:'collection', strIdName:'memberCollectionId', intId:memberCollectionId, strDivName:'memberCollectionsDiv'});
}

Member.saveCollection = function(bAddAnother) {
	Member.saveItem({strPath:'collection', strLabel:'collection', strIdName:'memberCollectionId', strDivName:'memberCollectionsDiv', bAddAnother:bAddAnother});
}

/**************************
********* COMMITTEE *******
**************************/

Member.addCommitteeMembership = function() {
	Util.showPopup('/members/profile/committee/createMembership?memberId=' + Member.memberId,500,'memberProfileDiv');
}

Member.editCommitteeMembership = function(committeeMemberId) {	
	Util.showPopup('/members/profile/committee/editMembership?committeeMemberId='+committeeMemberId,500,'memberProfileDiv',true);
}

Member.deleteCommitteeMembership = function(committeeMembershipId) {
	Util.confirm('Are you sure you want to delete this committee membership?',function() {
		$.ajax({type: 'POST',	
			url: '/members/profile/committee/deleteMembership',
			data: {memberId:Member.memberId,committeeMembershipId:committeeMembershipId},
			success: function() {Member.refreshCommitteeMembership();},
			error: Member.showError('The system encountered an error while trying to delete the committee.  Please refresh the page and try again.')
		});
		
	});
}

Member.saveCommitteeMemberTerm = function(committeeMemberId) {
	Util.clearErrors(true);
	var bSuccess = Util.submitForm({
		bPopup:true,
		bValidate:true,
		strURL:'/members/profile/committee/saveTerm',
		strFormName:'frmPopup',
		fnClearErrors:function() {Util.clearErrors(true);},
		fnOnInvalid:function(strValidationMessage) {
			$('.divErrorPopup').html(strValidationMessage);
			$('.divErrorPopup').show();
		},
		fnOnSuccess:function(strHtml) {
			if (strHtml == 'SUCCESS') {
				// close the popup
				Util.closePopup();
				Member.editCommitteeMembership(committeeMemberId);
			} else {
				// some error
				Util.closePopup();
				$('#memberProfileDiv').html(strHtml);
			}
		}
	});		
}

Member.refreshCommitteeMembership = function() {
	Member.hideError();
	$.ajax({type: 'GET',	
		url: '/members/profile/committee/view',
		data: {memberId:Member.memberId},
		success: function(strHtml) {
			$('#memberCommitteesDiv').html(strHtml);
		},
		error: function() {
			alert('error refreshing committee');
			Member.showError('The system encountered an error while trying to display the committee membership.  Please refresh the page and try again.');
		}
	});
}


/**********************************
********* COMMUNITY SERVICE *******
**********************************/
Member.addCommunityService = function() {
	Member.addItem({strPath:'communityService', strLabel:'Community Service', strIdName:'memberCommunityServiceId', strDivName:'memberCommunityServicesDiv'});
}

Member.editCommunityService = function(memberCommunityServiceId) {	
	Member.editItem({strPath:'communityService', strLabel:'Community Service', strIdName:'memberCommunityServiceId', intId:memberCommunityServiceId, strDivName:'memberCommunityServicesDiv'});
}

Member.deleteCommunityService = function(memberCommunityServiceId) {
	Member.deleteItem({strPath:'communityService', strLabel:'Community Service', strIdName:'memberCommunityServiceId', intId:memberCommunityServiceId, strDivName:'memberCommunityServicesDiv'});
}

Member.saveCommunityService = function(bAddAnother) {
	Member.saveItem({strPath:'communityService', strLabel:'Community Service', strIdName:'memberCommunityServiceId', strDivName:'memberCommunityServicesDiv', bAddAnother:bAddAnother});
}


/**********************************
******* BOARD PARTICIPATION *******
**********************************/
Member.addBoardParticipation = function() {
	Member.addItem({width:600, strPath:'boardParticipation', strLabel:'Board Participation', strIdName:'memberBoardParticipationId', strDivName:'memberBoardParticipationsDiv'});
}

Member.editBoardParticipation = function(memberBoardParticipationId) {	
	Member.editItem({width:600, strPath:'boardParticipation', strLabel:'Board Participation', strIdName:'memberBoardParticipationId', intId:memberBoardParticipationId, strDivName:'memberBoardParticipationsDiv'});
}

Member.deleteBoardParticipation = function(memberBoardParticipationId) {
	Member.deleteItem({strPath:'boardParticipation', strLabel:'Board Participation', strIdName:'memberBoardParticipationId', intId:memberBoardParticipationId, strDivName:'memberBoardParticipationsDiv'});
}

Member.saveBoardParticipation = function(bAddAnother) {
	Member.saveItem({width:600, strPath:'boardParticipation', strLabel:'Board Participation', strIdName:'memberBoardParticipationId', strDivName:'memberBoardParticipationsDiv', bAddAnother:bAddAnother});
}

/**********************************
******* ARTS *******
**********************************/
Member.addArt = function() {
	Member.addItem({width:500, strPath:'art', strLabel:'Art', strIdName:'memberArtId', strDivName:'memberArtsDiv'});
}

Member.editArt = function(memberArtId) {	
	Member.editItem({width:500, strPath:'art', strLabel:'Art', strIdName:'memberArtId', intId:memberArtId, strDivName:'memberArtsDiv'});
}

Member.deleteArt = function(memberArtId) {
	Member.deleteItem({strPath:'art', strLabel:'Art', strIdName:'memberArtId', intId:memberArtId, strDivName:'memberArtsDiv'});
}

Member.saveArt = function(bAddAnother) {
	Member.saveItem({strPath:'art', strLabel:'Art', strIdName:'memberArtId', strDivName:'memberArtsDiv', bAddAnother:bAddAnother});
}

/**********************************
********* OTHER CLUBS *************
**********************************/

Member.addOtherClub = function() {
	Member.addItem({strPath:'otherClub', strLabel:'Club / Affiliation', strIdName:'memberClubId', strDivName:'memberOtherClubsDiv'});
}

Member.editOtherClub = function(memberClubId) {	
	Member.editItem({strPath:'otherClub', strLabel:'Club / Affiliation', strIdName:'memberClubId', intId:memberClubId, strDivName:'memberOtherClubsDiv'});
}

Member.deleteOtherClub = function(memberClubId) {
	Member.deleteItem({strPath:'otherClub', strLabel:'Club / Affiliation', strIdName:'memberClubId', intId:memberClubId, strDivName:'memberOtherClubsDiv'});
}

Member.saveOtherClub = function(bAddAnother) {
	Member.saveItem({strPath:'otherClub', strLabel:'Club / Affiliation', strIdName:'memberClubId', strDivName:'memberOtherClubsDiv', bAddAnother:bAddAnother});
}


/**************************
********* SKILLS *******
**************************/

Member.editInterestSkills = function() {
	Util.showPopup('/members/profile/interestSkills/edit?memberProfileId='+Member.memberProfileId+'&memberId='+Member.memberId,800,'memberProfileDiv');
}

Member.saveInterestSkills = function() {
	Member.saveItem({strPath:'interestSkills', strLabel:'skills', strDivName:'memberInterestSkillsDiv'});
}

Member.editProfessionalSkills = function() {
	Util.showPopup('/members/profile/professionalSkills/edit?memberProfileId='+Member.memberProfileId+'&memberId='+Member.memberId,800,'memberProfileDiv');
}

Member.saveProfessionalSkills = function() {
	Member.saveItem({strPath:'professionalSkills', strLabel:'skills', strDivName:'memberProfessionalSkillsDiv'});
}


// turn on the star when mousing over
Member.profSkillMouseOver = function(skillId,level) {
	$('#profRatingStar_'+skillId+'_'+level).attr('src','/static/images/icons/ratingStarOn.png');
	$('#divProfRatingStar_'+skillId).html(Member.experienceLevels[level]);
}

// restore the selected skill when mousing out
Member.profSkillMouseOut = function(skillId,level) {
	Member.showProfSkillRating(skillId,$('#hdnProfSkill_'+skillId).val());
	$('#divProfRatingStar_'+skillId).html('');
}

Member.rateProfSkill = function(skillId,level) {
	$('#hdnProfSkill_'+skillId).val(level);
	Member.showProfSkillRating(skillId,level);
}

Member.showProfSkillRating = function(skillId,level) {
	var foundStar = false;
	if (level == '') {
		foundStar = true; // don't light up any
	}
	$('#profSkillRatingStars_' + skillId + ' img').each(function(index,objImage) {
		if (!foundStar) {
			objImage.src='/static/images/icons/ratingStarOn.png';
		} else {
			objImage.src='/static/images/icons/ratingStarOff.png';
		}
		// parse out the level to see if we've reached it
		var imgLevel = objImage.id.replace('profRatingStar_' + skillId + '_','');
		if (imgLevel == level) {
			foundStar = true;
		}
	});
}


// turn on the start when mousing over
Member.interestSkillMouseOver = function(skillId,level) {
	$('#interestRatingStar_'+skillId+'_'+level).attr('src','/static/images/icons/ratingStarOn.png');
	$('#divInterestRatingStar_'+skillId).html(Member.interestLevels[level]);
}

// restore the selected skill when mousing out
Member.interestSkillMouseOut = function(skillId,level) {
	Member.showInterestSkillRating(skillId,$('#hdnInterestSkill_'+skillId).val());
	$('#divInterestRatingStar_'+skillId).html('');
}

Member.rateInterestSkill = function(skillId,level) {
	$('#hdnInterestSkill_'+skillId).val(level);
	Member.showInterestSkillRating(skillId,level);
}

Member.showInterestSkillRating = function(skillId,level) {
	var foundStar = false;
	if (level == '') {
		foundStar = true; // don't light up any
	}
	$('#interestSkillRatingStars_' + skillId + ' img').each(function(index,objImage) {
		if (!foundStar) {
			objImage.src='/static/images/icons/ratingStarOn.png';
		} else {
			objImage.src='/static/images/icons/ratingStarOff.png';
		}
		// parse out the level to see if we've reached it
		var imgLevel = objImage.id.replace('interestRatingStar_' + skillId + '_','');
		if (imgLevel == level) {
			foundStar = true;
		}
	});
}

// erase this, not used with new Northstar Synching
/*
Member.storeBasicInfo = function() {
	//alert('old state code: ' + document.forms['frmMain']['profile.primaryAddress.stateCode'].value + '!');
	Member.basicInfo = new Object();
	$('#frmMain :input.trackBasicInfo').each(function() {
			Member.basicInfo[this.name]=$(this).val();
	});
}

Member.saveBasicInfoChange = function(memberId,objInput) {
	var strData='random=' + new Date().getTime() + '&memberId=' + memberId;
	// add in each of the old values
	for (p in Member.basicInfo) {
		strData += '&old_' + p + '='+ Member.basicInfo[p];
	}
	// add in each of the new values
	$('#frmMain :input.trackBasicInfo').each(function() {
		strData += '&' + this.name + '=' + $(this).val();
	});
		
	//	 + '&old_' + objInput.name + '=' + Member.basicInfo[objInput.name] + '&' + objInput.name + '=' + $(objInput).val();
	//alert('data to send: ' + strData);
	$.ajax({type: 'POST',	
		url: '/members/profile/saveBasicInfoChange',		
		data: strData,
		success: function(html) {
			Util.onAjaxSuccess(html, function(html) {
				//alert('saved');
			});
		},
		error: Util.onAjaxError
	});
}
*/

/**
* Update a member's profile when a form field is edited
* added a 3 second delay in case they're editing a bunch of fields at once, give them time to change them all before updating
*/
Member.autoSaveMyProfile = function() {
	window.clearTimeout(Member.autoSaveTimer);
	Member.autoSaveTimer = window.setTimeout(function() {
		//alert('saving');	
		var strRequestParams = 'random=' + new Date().getTime() + '&' + Util.formToString(document.forms['frmMain']);
		//alert('sending request: ' + strRequestParams);
		$.ajax({type: 'POST',	
			url: '/members/profile/autoSaveMyProfile',		
			data: strRequestParams,
			success: function(html) {
				Util.onAjaxSuccess(html, function(html) {
					//alert('saved');
				});
			},
			error: Util.onAjaxError
		});
	}, 3000); 
}


/**
* Update a membership candidate when a form field is edited
* added a 3 second delay in case they're editing a bunch of fields at once, give them time to change them all before updating
*/
Member.autoSaveMembershipCandidate = function() {
	window.clearTimeout(Member.autoSaveTimer);
	Member.autoSaveTimer = window.setTimeout(function() {
		//alert('saving');	
		var strRequestParams = 'random=' + new Date().getTime() + '&' + Util.formToString(document.forms['frmMain']);
		//alert('sending request: ' + strRequestParams);
		$.ajax({type: 'POST',	
			url: '/members/autoSaveMembershipCandidate',		
			data: strRequestParams,
			success: function(html) {
				Util.onAjaxSuccess(html, function(html) {
					//alert('saved');
				});
			},
			error: Util.onAjaxError
		});
	}, 3000); 
}

/**
 * called to validate that something was entered for a given section
 * bHidden: true if testing with a hidden field vs a checkbox
 */
Member.checkItemEntered = function(strItemType,bHidden) {
	//alert('validating: ' + strItemType);
	var objInput = document.forms['frmMain']['profile.no' + strItemType];
	if (objInput !== undefined && (objInput.type == 'checkbox' && !objInput.checked)) {
		//alert('found the input: ' + objInput.type + ' bHidden: ' + bHidden);
		return false;
	}
	return true;
}

Member.onInvalidMembershipForm = function(strErrorMessage) {
	// make sure the tab with the first invalid field is visible
	if (Validator.invalidField != null) {
		try {
			var strTabName = $(Validator.invalidField).parents('.tabBody').attr('id').replace('tabBody','');
			Util.showTab('memberTabs',strTabName);
		} catch(err) {
			// TODO
		}
    	$('.validationError').html(Validator.errorMessage).show();
	}
}


/**
* onClickInteractiveProfileField - called when the member clicks a field from the "review" page of a membership candidate
* first validates the form, so that any required fields will show up in red; 
* then focuses the first field referred to by the label clicked on
*/
Member.onClickInteractiveProfileField = function(strFieldName) {
	if (!Validator.isFormValid('frmMain')) {
		// just need to make required fields red...
		//alert('form not valid');
		//Member.onInvalidMembershipForm(Validator.errorMessage);
	}

	var tabName = "Review";
	var inputs = $(document.forms['frmMain'][strFieldName]);
	//console.log('count=' + inputs.length);
	//console.log('strFieldName=' + strFieldName);
	
	if (inputs.length > 1) {
		for (i = 0; i < inputs.length; i++) {
			var strTabName = $(document.forms['frmMain'][strFieldName][i]).parents('.tabBody').attr('id').replace('tabBody', '');
			//console.log('1+.strTabName=' + strTabName);
			if (strTabName.toLowerCase() != 'review') {
				tabName = strTabName;
			} 
		}		
	}
	else {
		var strTabName = $(document.forms['frmMain'][strFieldName]).parents('.tabBody').attr('id').replace('tabBody', '');
		//console.log('1.strTabName=' + strTabName);
		if (strTabName.toLowerCase() != 'review') {
			tabName = strTabName;
		} 		
	}
	
	Util.showTab('memberTabs',tabName);

	try {
		if (document.forms['frmMain'][strFieldName].length > 1) { // radiobuttons
			document.forms['frmMain'][strFieldName][0].focus();
		} else {
			document.forms['frmMain'][strFieldName].focus();
		}
	} catch(err) {
		// it's ok, could just be a hidden input
	}
}


/**
* real time filtering of the industry list
* Add a 1/2 second delay before filtering b/c the list is very long
*/
Member.filterIndustryList = function(event, strKeyword) {
	window.clearTimeout(Member.filterIndustriesTimer);
	Member.filterIndustriesTimer = window.setTimeout(function() {
		//var startTime = new Date().getTime();
		var strDebug = '';
		strKeyword = strKeyword.toLowerCase();
		//var code = (event.keyCode ? event.keyCode : event.which);
		$('#divIndustries_list .result').each(function(index,objResult) {	
			$(objResult).attr('visited','false');
		});		
		//strDebug += 'time1: ' + (new Date().getTime() - startTime);
		//startTime = new Date().getTime();
		$('#divIndustries_list .result').each(function(index,objResult) {		
			if ($(objResult).attr('visited') == 'true') {
				// do nothing, this one's been addressed already
			} else if ($(objResult).find('.resultText').html().toLowerCase().indexOf(strKeyword) >= 0) {
				// if the parent text matches, show all the children...
				$(objResult).attr('visited','true').show();
				// set all the children to show, mark as visited so this doesn't get overwritten
				$(objResult).find('.result').each(function(index2,objResult2) {
					$(objResult2).attr('visited','true').show();
				});
				// also make sure the parent is showing
				$(objResult).parents('.result').each(function(index2,objResult2) {
					$(objResult2).attr('visited','true').show();
				});
			} else {
				$(objResult).attr('visited','true').hide();
			}
		});
		//strDebug += ' time2: ' + (new Date().getTime() - startTime);
		//alert(strDebug);
	}, 500); 
}

Member.onChangeEmploymentIndustry = function(objCheckbox,industryId) {
	if (objCheckbox.checked) {
		// add the industry to the box of selected
		//alert('id: ' + industryId + ' description: ' + arrIndustry[industryId] + ' arr: ' + arrIndustry.length);
		var strHtml = '<div id="selIndustry_' + industryId + '" style="padding:2px;">' + arrIndustry[industryId] + 
			'<input type="hidden" name="industryIds" value="' + industryId + '"/>' +
			'<a href="javascript:Member.removeEmploymentIndustry(\'' + industryId + '\')"><img src="/images/icons/remove.gif" border="0" /></a>' +  
			'</div>';
		//alert('adding html: ' + strHtml);
		$('#divSelectedIndustries_list').append(strHtml);
	} else {
		Member.removeEmploymentIndustry(industryId);
	}
}

Member.removeEmploymentIndustry = function(industryId) {
	// uncheck the checkbox, also remove it from the list below
	$('#chkIndustry_' + industryId).removeAttr('checked');
	$('#selIndustry_' + industryId).remove();
}

//
/**
* real time filtering of the interestExpertise list
* Add a 1/2 second delay before filtering b/c the list is very long
*/
Member.filterInterestExpertiseList = function(event, strKeyword) {
	window.clearTimeout(Member.filterInterestsExpertiseTimer);
	Member.filterInterestsExpertiseTimer = window.setTimeout(function() {
		//var startTime = new Date().getTime();
		var strDebug = '';
		strKeyword = strKeyword.toLowerCase();
		//var code = (event.keyCode ? event.keyCode : event.which);
		$('#divInterestsExpertise_list .result').each(function(index,objResult) {	
			$(objResult).attr('visited','false');
		});		
		//strDebug += 'time1: ' + (new Date().getTime() - startTime);
		//startTime = new Date().getTime();
		$('#divInterestsExpertise_list .result').each(function(index,objResult) {		
			if ($(objResult).attr('visited') == 'true') {
				// do nothing, this one's been addressed already
			} else if ($(objResult).find('.resultText').html().toLowerCase().indexOf(strKeyword) >= 0) {
				// if the parent text matches, show all the children...
				$(objResult).attr('visited','true').show();
				// set all the children to show, mark as visited so this doesn't get overwritten
				$(objResult).find('.result').each(function(index2,objResult2) {
					$(objResult2).attr('visited','true').show();
				});
				// also make sure the parent is showing
				$(objResult).parents('.result').each(function(index2,objResult2) {
					$(objResult2).attr('visited','true').show();
				});
			} else {
				$(objResult).attr('visited','true').hide();
			}
		});
		//strDebug += ' time2: ' + (new Date().getTime() - startTime);
		//alert(strDebug);
	}, 500); 
}

Member.onChangeMemberInterestExpertise = function(objCheckbox,interestExpertiseId) {
	// NOTE: this is handled differently from Industry in that only ONE interestExpertise may be selected from the list at any time
	if (objCheckbox.checked) {

		$('.divErrorPopup').hide();

		// remove previous checks in checkboxes
		$('#divInterestsExpertise_list input:checked').each(function(index,objResult) {	
			//this unchecks all other checkboxes
			$(objResult).not(objCheckbox).attr('checked',false);
		});		

		// add the interest/expertise to the box of selected
		//alert('id: ' + interestExpertiseId + ' description: ' + arrIndustry[industryId] + ' arr: ' + arrIndustry.length);
		var strHtml = '<div id="selInterestExpertise_' + interestExpertiseId + '" style="padding:2px;">' + arrInterestExpertise[interestExpertiseId] + 
			'<input type="hidden" name="interestExpertiseId" value="' + interestExpertiseId + '"/>' +
			'<a href="javascript:Member.removeMemberInterestExpertise(\'' + interestExpertiseId + '\')"><img src="/images/icons/remove.gif" border="0" /></a>' +  
			'</div>';
		//alert('adding html: ' + strHtml);
		$('#divSelectedInterestsExpertise_list').empty(); //this clears the path list
		$('#divSelectedInterestsExpertise_list').append(strHtml);
	} 
	else {
		Member.removeMemberInterestExpertise(interestExpertiseId);
	}

}

Member.addSearchInterestExpertiseDescriptionRow = function(interestExpertiseId) {

	//remove any existing rows of this interestExpertise first so we don't get duplicates
	$('#selInterestExpertise_' + interestExpertiseId).remove();

	// add the interest/expertise to the box of selected
	var strHtml = '<div id="selInterestExpertise_' + interestExpertiseId + '" style="padding:2px;">' + arrInterestExpertise[interestExpertiseId] + 
		'<input type="hidden" class="interestExpertiseIds" name="interestExpertiseIds" value="' + interestExpertiseId + '"/>' +
		'<a href="javascript:Member.removeSearchInterestExpertise(\'' + interestExpertiseId + '\')"><img src="/images/icons/remove.gif" border="0" /></a>' +  
		'</div>';
	$('#divSelectedInterestsExpertise_list').append(strHtml);
}


Member.removeMemberInterestExpertise = function(interestExpertiseId) {
	// uncheck the checkbox, also remove it from the list below
	$('#chkInterestExpertise_' + interestExpertiseId).removeAttr('checked');
	$('#selInterestExpertise_' + interestExpertiseId).remove();

	$('.divErrorPopup').html('Please select a category.').show();
}


// MEMBER SEARCH - interests and expertise
//this clears all descendant checkboxes, as well as the parent. NON-RECURSIVE
Member.clearAllSearchInterestExpertiseChildren = function(interestExpertiseId) {
	Member.removeSearchInterestExpertise(interestExpertiseId)
	var objDivbox = $('#divInterestExpertise_' + interestExpertiseId)
	var allDescendantDivs = $(objDivbox).find('.result')

	for (i = 0; i < allDescendantDivs.length; i++) {
		var childDiv = allDescendantDivs[i] 
		var childInterestExpertiseId = $(childDiv).find('input:checkbox:first').val()
		Member.removeSearchInterestExpertise(childInterestExpertiseId)
	}
}

//this selects all descendant checkboxes, as well as the parent. NON-RECURSIVE
Member.selectAllSearchInterestExpertiseChildren = function(interestExpertiseId) {
	$('#chkInterestExpertise_' + interestExpertiseId).attr('checked', true);
	Member.addSearchInterestExpertiseDescriptionRow(interestExpertiseId);

	var objDivbox = 	$('#divInterestExpertise_' + interestExpertiseId)
	var allDescendantDivs = $(objDivbox).find('.result')

	for (i = 0; i < allDescendantDivs.length; i++) {
		var childDiv = allDescendantDivs[i] 
		var childInterestExpertiseId = $(childDiv).find('input:checkbox:first').val()
	  $('#chkInterestExpertise_' + childInterestExpertiseId).attr('checked', true);
		Member.addSearchInterestExpertiseDescriptionRow(childInterestExpertiseId);
	}
}


Member.onChangeSearchInterestExpertise = function(objCheckbox,interestExpertiseId) {
	// NOTE: this behaves like the industry list where multiple selections are allowed
	if (objCheckbox.checked) {
		// add the interest/expertise to the box of selected
		//Member.addSearchInterestExpertiseDescriptionRow(interestExpertiseId);
		Member.selectAllSearchInterestExpertiseChildren(interestExpertiseId);
	} 
	else {
		Member.clearAllSearchInterestExpertiseChildren(interestExpertiseId)
	}
}

Member.removeSearchInterestExpertise = function(interestExpertiseId) {
	// uncheck the checkbox, also remove it from the list below
	$('#chkInterestExpertise_' + interestExpertiseId).removeAttr('checked');
	$('#selInterestExpertise_' + interestExpertiseId).remove();
}

//

Member.inactivateMember = function(memberId) {
	Util.showPopup('/admin/members/inactivateMember?memberId=' + memberId);
}

Member.inactivateVisitor = function(memberId) {
	Util.showPopup('/admin/members/inactivateVisitor?memberId=' + memberId);
}

// proxy login
Member.logInAsUser = function(userId) {
	Util.confirm('Are you sure you want to log in as this User?',function() {
		Util.doAction('/admin/members/proxyLogInAsUser/' + userId);
	});
}

Member.emailLoginInstructions = function(userId) {

	Util.disableNewButton('#btnEmailLogin','Processing...');
	//ajax call
	var queryUrl = '/admin/members/emailLoginInstructions/' + userId;

	//console.log('query: ' + queryUrl);

	Util.submitForm({
			bPopup:true,
		bValidate:false,
		strURL: queryUrl,
		strFormName:'frmMain',
		fnOnError:function(response) {
			Util.enableNewButton('#btnEmailLogin','Email Login Instructions');
			Util.showPopupAlert('Error sending email',jsonResponse.message);
		},
		fnOnSuccess:function(response) {
			//console.log('** RESPONSE **:' + response);
			//show the dupe error message via popup
			var jsonResponse = JSON.parse(response);
			Util.enableNewButton('#btnEmailLogin','Email Login Instructions');
			if (jsonResponse.status == "SUCCESS") {
				Util.showPopupAlert('Email sent', "The email containing the login instructions was successfully sent.");
			}
			else {
				Util.showPopupAlert('Error sending email',jsonResponse.message);
			}
		}
	});			

}